import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortDescending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlockSortDescending"><Path d="M10.5 3.5H3.5V10.5H10.5V3.5Z" stroke="currentColor"/><Path d="M10.5 13.5H3.5V20.5H10.5V13.5Z" stroke="currentColor"/><Path d="M17.5 17V6" stroke="currentColor"/><Path d="M13 13L17.5 17.5L22 13" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlockSortDescending;
